import React from 'react'

import HidingElement from '../utils/HidingElement'
import PopupFrame from '../../layout/parts/PopupFrame'
import Datetime from '../utils/Datetime'
import { Line, RedLine, Edit, Rub } from '../utils/Symbols'
import { ErrorMessages } from '../utils/ErrorMessages'
import Pixel, { PIXEL_ACTIONS } from '../utils/Pixel'
import { ChosenTickets } from './ChosenTickets'

class CheckOrderPopup extends HidingElement {

    constructor(props) {
        super(props)
        this.state = {
            errors: this.props.errors || {},
        }
    }

    static getDerivedStateFromProps(nextProps) {
        return { errors: nextProps.errors };
    }

    renderIfEnabled() {
        return (
            <PopupFrame
                title="Подтверждение заказа"
                onClose={this.props.onClose}>

                <div className="tickets-popup-head">
                    {this.props.performance.event.name}
                </div>
                <div>
                    {this.props.performance.name}
                </div>

                <RedLine className="mobile-only" />

                <div className="tickets-customer-info-block">
                    <div>{this.props.name}</div>
                    <div>{this.props.email}</div>
                    <div>{this.props.phone}</div>
                    <div><Datetime datetime={this.props.performance.datetime} /></div>
                    <div>{this.props.performance.hall}</div>
                </div>

                <Line className="desktop-only" />
                <RedLine className="mobile-only" />

               <div>{this.getChosenTicketInfo()}</div> 

                <div className="tickets-popup-subtitle">
                    Итого:&nbsp;
                    {this.getChosenTicketsCost()} <Rub height="14" />
                </div> 
                <a className="tickets-popup-edit-link"
                        href="#goback" 
                        onClick={this.props.back}>
                    <Edit />
                    Редактировать
                </a>
                <br />

                <div className="tickets-button-block">
                    <input className="tickets-button-primary tickets-pay-button"
                        type="submit"
                        onClick={this.props.next}
                        disabled={this.props.buttonDisabled}
                        value="Оплатить" />
                </div>

                <ErrorMessages errors={this.state.errors} />

                <Pixel 
                    eventId={this.props.performance.event.uuid} 
                    performanceId={this.props.performance.uuid} 
                    action={PIXEL_ACTIONS.WIDGET_CHECK_ORDER} />


            </PopupFrame>
        )
    }

    getChosenTicketInfo = () => {
        var ticketsInfo = this.getChosenTicketCosts()
        return ticketsInfo.map((ticketInfo, id, tickets) => {
            return (
                <div key={'chosenTicket' + id}>
                    <div className="tickets-popup-subtitle">{ticketInfo.name}</div>
                    <div>Кол-во билетов: {ticketInfo.count}</div> 
                    { tickets.length !== 1 &&
                        <div>Cумма: {ticketInfo.cost} <Rub height="14" /></div>
                    }
                </div>
            )
        })
    }

    getChosenTicketsCost = () => {
        return this.props.chosenTickets.getCost()
    }

    getChosenTicketCosts = () => {
        const groupedTickets = this.getChosenTicketsByGroups()
        const info = []
        Object.keys(groupedTickets).forEach(name => {
            const tickets = new ChosenTickets(groupedTickets[name])
            info.push({
                name: name,
                count: tickets.getCount(),
                cost: tickets.getCost(),
            })
        })
        return info
    }

    getChosenTicketsByGroups = () => {
        var groupedTickets = {}
        this.props.chosenTickets.tickets.forEach(ticket => {
            if (ticket.name in groupedTickets) {
                groupedTickets[ticket.name].push(ticket)
            } else {
                groupedTickets[ticket.name] = [ticket,]
            }
        })
        return groupedTickets
    }
}

export default CheckOrderPopup
